import { ObjectId } from 'bson';

export default class MongoProjectRead {
  _id = null;

  projectId = "";
  readerIds = [];

  constructor() {
    this._id = new ObjectId();
  }
}
